import { Component, EventEmitter, forwardRef, Output } from '@angular/core';
import { defaultLanguageKey, LanguageKey, publishedLanguageLabels } from 'src/app/shared/models/language.dto';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'vee-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
  standalone: false,

  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LanguageSelectComponent),
      multi: true,
    },
  ],
})
export class LanguageSelectComponent implements ControlValueAccessor {
  value!: LanguageKey;
  isDisabled = false;

  languageLabels: Partial<Record<LanguageKey, string>> = publishedLanguageLabels;
  languages = Object.keys(this.languageLabels) as LanguageKey[];

  private onChange = (lang: LanguageKey) => {};
  private onTouched = () => {};
  @Output() change = new EventEmitter<LanguageKey>();

  constructor() {}

  changeLanguage(lang: LanguageKey) {
    this.value = lang;
    this.change.emit(lang);
    this.onChange(lang);
    this.onTouched();
  }

  writeValue(lang: LanguageKey | null): void {
    this.value = lang ?? defaultLanguageKey;
  }

  registerOnChange(fn: (lang: LanguageKey) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
